import { DASHBOARD_REQUEST, DASHBOARD_SUCCESS, DASHBOARD_ERROR, FARM_STATISTICS_REQUEST, FARM_STATISTICS_SUCCESS, FARM_STATISTICS_ERROR } from "./actionTypes";

const initialState = {
  loading: false,
  data: {},
  error: null,
  farmStatistics: {
    loading: false,
    data: null,
    error: null,
  },
};

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_REQUEST:
      return { ...state, loading: true };

    case DASHBOARD_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case DASHBOARD_ERROR:
      return { ...state, loading: false, error: action.payload };

    case FARM_STATISTICS_REQUEST:
      return { 
        ...state, 
        farmStatistics: { ...state.farmStatistics, loading: true, error: null } 
      };

    case FARM_STATISTICS_SUCCESS:
      return { 
        ...state, 
        farmStatistics: { 
          ...state.farmStatistics, 
          loading: false, 
          data: action.payload 
        } 
      };

    case FARM_STATISTICS_ERROR:
      return { 
        ...state, 
        farmStatistics: { 
          ...state.farmStatistics, 
          loading: false, 
          error: action.payload 
        } 
      };

    default:
      return state;
  }
};

export default DashboardReducer;
